import { FrameData } from '../../types';
import { hsl } from '../../utils/colorUtils';
import { LayerRenderer } from './LayerRenderer';

export class SolidBackgroundRenderer implements LayerRenderer {
  init(): void {}

  render(
    ctx: CanvasRenderingContext2D,
    _frame: FrameData,
    settings: Record<string, number>,
    width: number,
    height: number,
  ): void {
    const colorHue = settings.colorHue ?? 0;
    const saturation = settings.saturation ?? 0;
    const lightness = settings.lightness ?? 5;
    ctx.fillStyle = hsl(colorHue, saturation, lightness);
    ctx.fillRect(0, 0, width, height);
  }

  resize(): void {}
  destroy(): void {}
}
